"use client";

import type { BrandConfig } from "@ui-d2c/types";
import { createContext, useContext } from "react";

type AppConfig = {
  brand: BrandConfig;
};

const ConfigContext = createContext<AppConfig | null>(null);

export function ConfigProvider({
  children,
  value,
}: {
  children: React.ReactNode;
  value: AppConfig;
}) {
  return (
    <ConfigContext.Provider value={value}>{children}</ConfigContext.Provider>
  );
}

export function useConfig() {
  const context = useContext(ConfigContext);
  if (!context) {
    throw new Error("useConfig must be used inside a ConfigProvider");
  }
  return context;
}
